export default __webpack_public_path__ + "static/travel-to-fashion-week-without-the-invitejpg-fa6b12d73e6c497df5851764238711be.jpg";